import { render, staticRenderFns } from "./Swiper.vue?vue&type=template&id=3c24aff4&"
import script from "./Swiper.vue?vue&type=script&lang=js&"
export * from "./Swiper.vue?vue&type=script&lang=js&"
import style0 from "./Swiper.vue?vue&type=style&index=0&id=3c24aff4&prod&lang=less&less=scoped&"
import style1 from "./Swiper.vue?vue&type=style&index=1&id=3c24aff4&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports